export default [
    {
        path: '/newsletter/media-viewer/:path?',
        name: 'newsletter_media_viewer',
        props(route: any) {
            return { path: route.params.path ? decodeURIComponent(route.params.path) : null };
        },
        component: () => import('@src/newsletter/newsletter-media-viewer.vue'),
        meta: {
            title: 'Bilder für Newsletter',
            role: 'ROLE_NEWSLETTER_IMAGE',
        },
    },
];
